import { cn } from '#app/shared/lib/misc.js'
import { Icon, type IconName } from '#app/shared/ui/icons/Icon.js'

type Props = {
  icon: IconName
  title: string
  description: string
  isRounded?: boolean
  className?: string
}

export default function Card({
  icon,
  title,
  description,
  className,
  isRounded = true,
}: Props) {
  return (
    <div
      className={cn(
        `
          flex min-h-[200px] max-w-[377px] flex-col justify-left gap-2
          rounded-lg border border-neutral-75 p-6

          md:p-7
        `,
        className,
      )}
    >
      <div
        className={cn(
          `flex h-[40px] w-[40px] justify-center`,
          isRounded
            ? `rounded-full border-[2px] border-primary-500 border-opacity-20`
            : '',
        )}
      >
        <Icon className="text-primary-500" name={icon} size="28px" />
      </div>

      <p className="text-h5-bold text-neutral-900">{title}</p>
      <p className="flex-1 text-subtitle1-medium text-neutral-700">
        {description}
      </p>
    </div>
  )
}
